/* eslint-disable max-len */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import {
  Popup,
} from 'semantic-ui-react';

import {
  BoxItens,
  BoxSearch,
  BoxSelect,
  CheckboxInput,
  QuestionMarkIcon,
  ContainerIcon,
  ErrorMessage,
  InputFind,
  ItensList,
  Main,
  Message,
  Radio,
  SubItens,
  MoreCountriesBold,
  MoreCountriesDiv,
  OtherCountriesDiv,
} from './styles';

const HEAD_HOVER_TEXT = 'We have smaller panels in these countries. Consider removing all other demographic criteria and screener questions while recruiting. ';
const BOTTOM_HOVER_TEXT = 'We accept participants from all countries, even if the country isn’t listed here. ';

const handlePopUpHeadText = () => (
  <p>
    {HEAD_HOVER_TEXT}
    <a
      href="https://help.playbookux.com/en/articles/6158916-tips-on-successfully-recruiting-from-more-countries"
      target="_blank"
      rel="noopener noreferrer"
    >
      Tips on successfully recruiting participants
    </a>
  </p>
);

const handlePopUpBottomText = () => (
  <p>
    {BOTTOM_HOVER_TEXT}
    <a
      href="https://help.playbookux.com/en/articles/6158926-recruiting-from-other-countries-not-listed"
      target="_blank"
      rel="noopener noreferrer"
    >
      Tips on recruiting from a country that you don’t see here
    </a>
  </p>
);

const SelectList = (props) => {
  const {
    error,
    items,
    moreItems,
    message,
    onChange,
    singleSelect,
    values,
    isCountryList,
    key,
  } = props;
  const [filter, setFilter] = useState('');
  const [showItems, setShowItems] = useState([]);
  const [showMoreCountriesSection, setShowMoreCountriesSection] = useState([]);

  useEffect(() => {
    setShowItems(items);
    setShowMoreCountriesSection(moreItems);
  }, []);

  const isOtherCountries = (item) => {
    if (_.isObject(item)) {
      return item.value === 'other';
    }

    return item === 'other';
  };

  const filterFront = ({ value }) => {
    let newItems = items;
    let newMoreItems = moreItems;

    if (value.length >= 3) {
      newItems = _.filter(
        newItems,
        (item) => _.lowerCase(_.isObject(item) ? item.text : item).includes(_.lowerCase(value)),
      );

      newMoreItems = _.filter(
        newMoreItems,
        (item) => _.lowerCase(_.isObject(item) ? item.text : item).includes(_.lowerCase(value)),
      );
    }

    setFilter(value);
    setShowItems(newItems);
    setShowMoreCountriesSection(newMoreItems);
  };

  const clearInput = () => {
    setFilter('');
    setShowItems(items);
    setShowMoreCountriesSection(moreItems);
  };

  return (
    <Main>
      <BoxSelect>
        <BoxItens error={error}>
          <BoxSearch>
            <InputFind
              placeholder="Search"
              value={filter}
              onChange={({ target }) => filterFront(target)}
            />
            <span
              className="cancel"
              onClick={() => clearInput()}
              role="button"
              tabIndex="0"
              onKeyPress={() => { }}
            >
              Cancel
            </span>
          </BoxSearch>

          <ItensList>
            {message && (
              <Message>
                {message}
              </Message>
            )}
            {showItems.map((item) => (
              <SubItens key={`${key}-${_.isObject(item) ? item.value : item}`}>
                {!singleSelect && (
                  <CheckboxInput
                    checked={values[_.isObject(item) ? item.value : item || false]}
                    onChange={(e, obj) => onChange(e, obj)}
                    type="checkbox"
                    name={_.isObject(item) ? item.value : item}
                    label={_.isObject(item) ? item.text : item}
                  />
                )}
                {singleSelect && (
                  <Radio
                    checked={values[_.isObject(item) ? item.value : item] || false}
                    onChange={(e, obj) => onChange(e, obj)}
                    type="checkbox"
                    name={_.isObject(item) ? item.value : item}
                    label={_.isObject(item) ? item.text : item}
                  />
                )}
              </SubItens>
            ))}
            {
              isCountryList && (
                <MoreCountriesDiv>
                  <MoreCountriesBold>More Countries</MoreCountriesBold>
                  <Popup
                    content={handlePopUpHeadText()}
                    mouseEnterDelay={500}
                    mouseLeaveDelay={3000}
                    hideOnScroll
                    trigger={(
                      <ContainerIcon>
                        <QuestionMarkIcon name="question" />
                      </ContainerIcon>
                    )}
                  />
                </MoreCountriesDiv>
              )
            }

            {showMoreCountriesSection?.map((item) => (
              <SubItens key={item.value}>
                {moreItems && !isOtherCountries(item) && (
                  <CheckboxInput
                    checked={values[_.isObject(item) ? item.value : item || false]}
                    onChange={(e, obj) => onChange(e, obj)}
                    type="checkbox"
                    name={_.isObject(item) ? item.value : item}
                    label={_.isObject(item) ? item.text : item}
                  />
                )}
                {moreItems && isOtherCountries(item) && (
                  <OtherCountriesDiv>
                    <CheckboxInput
                      checked={values[_.isObject(item) ? item.value : item || false]}
                      onChange={(e, obj) => onChange(e, obj)}
                      type="checkbox"
                      name={_.isObject(item) ? item.value : item}
                      label={_.isObject(item) ? item.text : item}
                    />
                    <Popup
                      content={handlePopUpBottomText()}
                      mouseEnterDelay={500}
                      mouseLeaveDelay={3000}
                      hideOnScroll
                      trigger={(
                        <ContainerIcon>
                          <QuestionMarkIcon name="question" />
                        </ContainerIcon>
                      )}
                    />
                  </OtherCountriesDiv>
                )}

              </SubItens>
            ))}

          </ItensList>
        </BoxItens>

        {(error) && (
          <ErrorMessage>
            <span>{error}</span>
          </ErrorMessage>
        )}

      </BoxSelect>
    </Main>
  );
};

SelectList.propTypes = {
  error: PropTypes.string,
  items: PropTypes.array.isRequired,
  moreItems: PropTypes.array,
  message: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  singleSelect: PropTypes.bool,
  values: PropTypes.array,
  isCountryList: PropTypes.bool,
  key: PropTypes.string,
};

SelectList.defaultProps = {
  moreItems: null,
  error: null,
  message: null,
  singleSelect: false,
  values: null,
  isCountryList: false,
  key: 0,
};

export default SelectList;
